<template>
  <div class="event-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <BubbleTextRow v-if="message.text"><BubbleTextMsg :text="message.text" /></BubbleTextRow>

    <MsgblContent :type="message.direction" v-if="message.showEntityLink">
      <MsgblLinkHeader icon="event"
                       :title="message.appointment_title"
                       @click="navigateTo" />
    </MsgblContent>

    <MsgblContent :type="message.direction" v-if="message.showEntityCard">
      <MsgblLinkHeader icon="event"
                       :title="message.appointment_title"
                       @click="navigateTo" />

      <MsgblTextRow class="event-when">
        <MsgblTextLabel>{{$t('appointment.info.when')}}:</MsgblTextLabel>
        <MsgblTextValue>{{event.start_time_h}}</MsgblTextValue>
      </MsgblTextRow>

      <MsgblTextRow class="where" v-if="showStaff && message.staff">
        <MsgblTextLabel>{{$t('booking.info.with')}}:</MsgblTextLabel>
        <MsgblTextValue>{{message.staff.display_name}}</MsgblTextValue>
      </MsgblTextRow>

      <MsgblTextRow class="event-where" v-if="event.where_h">
        <MsgblTextLabel>{{$t('booking.info.where')}}:</MsgblTextLabel>
        <MsgblBooking :booking="event" />
      </MsgblTextRow>

      <MsgblTextRow class="event-amount" v-if="event.payment_status">
        <MsgblTextLabel data-qa="payment-status-state" :class="colorStatus">{{event.payment_status.state_summary.state_h}}:</MsgblTextLabel>
        <MsgblTextValue data-qa="payment-status-amount" >{{price}}</MsgblTextValue>
      </MsgblTextRow>

      <MsgblTextRow class="event-status">
        <MsgblTextLabel>{{$t('booking.info.status')}}:</MsgblTextLabel>
        <MsgblTextValue>{{event.state_summary.state_h}}</MsgblTextValue>
      </MsgblTextRow>

      <MsgblTextRow class="event-request-data"
                    v-for="(data, i) in requestData"
                    :key="i">
        <template v-if="data[1]">
          <MsgblTextLabel>{{data[0]}}:</MsgblTextLabel>
          <MsgblTextValue>{{data[1]}}</MsgblTextValue>
        </template>
      </MsgblTextRow>

      <MsgblActions v-if="actions"
                    :actions="actions"
                    @action="actionClicked" />
    </MsgblContent>
  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblBooking,
  MsgblContent,
  MsgblLinkHeader,
  MsgblTextRow,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblActions,
} from './helpers'

export default {
  name: 'EventBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    MsgblBooking,
    MsgblContent,
    MsgblLinkHeader,
    MsgblTextRow,
    MsgblTextLabel,
    MsgblTextValue,
    MsgblActions,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    showStaff: {
      type: Boolean,
      defualt: false
    }
  },
  computed: {
    event() {
      return this.message.messageable
    },
    actions() {
      if (this.event.state_summary.state === 'cancelled' || this.event.state_summary.state === 'pending') return null

      return [{name: 'remove', name_h: this.$t('event_attendance.action.remove.title')}]
    },
    requestData() {
      return this.event.request_data
    },
    colorStatus() {
      const colorStatus = {
        paid:       'status-accent',
        created:    'status-alert',
        sent:       'status-alert',
        cancelled:  'status-warning',
        pending:    'ps-status-outstanding',
        overdue:    'ps-status-overdue',
        hidden:     'status-primary',
      }

      return colorStatus[this.event.payment_status.state_summary.state]
    },
    price(){
      if (['Invoice', 'Cart'].includes(this.event.payment_status.payable_type))
        return this.event.price_h;
      return this.event.payment_status.amount_to_pay_h;
    }
  },
  methods: {
    actionClicked({action}) {
      const data = {event: this.message}
      this.$frontageApi.send('event-bubble-action', {action, data})
    },
    navigateTo() {
      this.$frontageApi.navigateTo('app.event', {uid: this.event.event_instance_uid})
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';
@import '@/assets/scss/abstract/_i18n-mixins';

.event-bubble {

  .status-accent {
    color: $status_success;
  }

  .status-warning {
    color: $status_error;
  }

  .status-alert {
    color: $status_alert;
  }

  .status-primary {
    color: $status_primary;
  }

  .ps-status-outstanding {
    color: $ps_outstanding
  }

  .ps-status-overdue {
    color: $ps_overdue
  }

}
</style>
